module.exports = __webpack_public_path__ + "img/20190928142648963.033f0299.jpg";